import { createSlice } from '@reduxjs/toolkit';

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: {
    isPartialLogin: false,
    isLoggedIn: false,
    user: {},
    loading: false,
    error: null,
    viewType: '',
  },
  reducers: {
    userLoginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    userLoginSuccess: (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.isPartialLogin = false;
      state.user = action.payload;
      state.error = null;
    },
    userPartialRegister: (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.isPartialLogin = true;
      state.user = action.payload;
      state.error = null;
    },
    userRegisterSucess: (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.isPartialLogin = false;
      state.user = action.payload;
      state.error = null;
    },
    userLoginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    userLogout: (state) => {
      state.isPartialLogin = false;
      state.isLoggedIn = false;
      state.user = {};
      state.viewType = '';
      state.loading = false;
      state.error = null;
    },
    userUpdateProfileRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    userUpdateProfileSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    userUpdateProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    userUpdateViewType: (state, action) => {
      state.viewType = action.payload;
    },
  },
});

export const {
  userLoginRequest,
  userLoginSuccess,
  userLoginFailure,
  userLogout,
  userPartialRegister,
  userUpdateProfileRequest,
  userUpdateProfileSuccess,
  userUpdateProfileFailure,
  userUpdateViewType,
} = userInfoSlice.actions;
export default userInfoSlice.reducer;
